import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { TextStyle } from '@client/style/TextStyles';
import gsap from 'gsap';
import FilterStore from '@client/modules/ListModules/FilterStore';
import CloseButton from '@client/assets/svgs/plus.svg';

const SVGWrapper = styled.div`
	margin-left: 10px;

	width: 24px;
	height: 24px;
	display: flex;
`;

const Close = styled(CloseButton)`
	width: 23px;
	height: 23px;
`;

const FilterContainer = styled.button`
	display: flex;
	${TextStyle.size('p3')}
	${TextStyle.family('title')}
	${TextStyle.weight('bold')}
	align-items: center;
	color: currentColor;
`;

const FilterInlineText = styled.span``;

export default function FilteredListFilterToggle({ isOpen, onClick }: { onClick: () => void; isOpen: boolean }) {
	const plusRef = useRef<HTMLDivElement | null>(null);

	const activeFilterAmount = FilterStore.use(state => state.activeFilters);

	useEffect(() => {
		if (isOpen) {
			handleOpen();
		} else {
			handleClose();
		}
	}, [isOpen]);

	const handleClose = () => {
		if (!plusRef.current) return;
		gsap.to(plusRef.current, {
			duration: 0.1,
			transform: 'rotate(0)',
		});
	};

	const handleOpen = () => {
		if (!plusRef.current) return;
		gsap.to(plusRef.current, {
			duration: 0.1,
			transform: 'rotate(45deg)',
		});
	};

	return (
		<FilterContainer onClick={onClick}>
			Filter&nbsp;{activeFilterAmount > 0 && <FilterInlineText>({activeFilterAmount})</FilterInlineText>}
			<SVGWrapper ref={plusRef}>
				<Close></Close>
			</SVGWrapper>
		</FilterContainer>
	);
}
